import parkingService from '@/api/parking'
import { PARKING } from '../types'

export default {
  namespaced: true,
  state: {
    parkingsName: '',
    parkingsBySite: []
  },
  mutations: {
    [PARKING.AVAILABLE_PARKINGS_SET](state, parkingsName) {
      state.parkingsName = parkingsName
    },
    [PARKING.SET_PARKINGS_BY_SITE](state, parkingsBySite) {
      state.parkingsBySite = parkingsBySite
    },
  },
  actions: {
    async getAvailableParkings({ commit }) {
      let response = await parkingService.getAvailableParkings()
      commit(PARKING.AVAILABLE_PARKINGS_SET, response.data)
    },
    async getParkingsBySite ({commit, dispatch}, siteId) {
      return new Promise((resolve) => {
        parkingService.getParkingsBySite(siteId).then(response => {
          commit(PARKING.SET_PARKINGS_BY_SITE, response.data)
          resolve()
        }).catch(() => {
          commit(PARKING.SET_PARKINGS_BY_SITE, [])
        }).finally(
          dispatch('Global/hideLoading', null, {root:true})
        )
      })
    }
  }

}
